import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import './textarea.css'
import InfoBar from '../InfoBars';
interface TextAreaProps {
  placeholder: string;
  inputType?: 'general' | 'entered' | 'error' | 'success' | 'disabled';
  type: string; //text | email | password |
  isDisabled: boolean;
  className?: string;
  labelName?: string;
  required?: boolean;
  onChange: (value: string,event?:any) => void;
  value?: any;
  maximumLength?: number ;
  inputId?:any;
  errorMessage?:string;
  disablePastDates?:boolean;
  maxDate?:string;
  minDate?:string;
  onClick?:()=>void
}
const TextArea = ({
  inputType = 'general',
  placeholder,
  type,
  isDisabled,
  className,
  errorMessage,
  labelName,
  required,
  onChange,
  value,
  inputId,
  onClick
}: TextAreaProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value,e);
    
  };
  return (
    <div className={`input-field-container  ${className}`}>
      {labelName && (
        <label
          className={`label-name-from-parent ${required && 'yes'} ${isDisabled}`}
        >
          {labelName}
        </label>
      )}
      <InputGroup
        className={` input-field-group input-field-group-${inputType}`}
        onClick={()=>{
          if(onClick){
            onClick();
          }
        }}
      >
        <Form style={{width:'100%'}}>
            <Form.Group>
                <Form.Control 
                    as="textarea" 
                    value={value}
                    className={`text-bar-input ${isDisabled} ${type === 'number' ? 'no-spinner' : ''}`}
                    id={inputId}
                    onChange={handleChange} 
                    placeholder="Type here"
                />
            </Form.Group>
        </Form>
      </InputGroup>
      <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="input_field_class"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
export default TextArea;
